(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jf-play"] && !Shopify.designMode) return;
  try {
    
(function (scope) {
  'use strict';
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  const esc = value => String(value == null ? '' : value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const sizeIndex = product => product.options.findIndex(name => /^(tamanho|size|numero|shoe size|tamanho eu|eu size)$/.test(normalize(name)));
  const sizeNumber = value => Number((String(value).match(/(?:^|\D)(\d{2}(?:[.,]5)?)/) || [])[1]?.replace(',','.'));
  function selectProducts(products, collection, size, budget, minSize = 35) {
    return products.filter(p => p.collections.includes(collection)).flatMap(p => {
      const i = sizeIndex(p);
      if (i < 0) return [];
      const variants = p.variants.filter(v => v.available && v.price <= budget && (size === 'unknown' ? sizeNumber(v.options[i]) >= minSize : normalize(v.options[i]) === normalize(size)));
      variants.sort((a, b) => a.price - b.price);
      return variants.length ? [{product:p, variant:variants[0]}] : [];
    }).sort((a,b) => a.variant.price - b.variant.price || a.product.id.localeCompare(b.product.id)).slice(0, 6);
  }
  function route(config, game, trail) {
    const g = config.games.find(item => item.id === game);
    if (!g || game === 'duo') return null;
    let node = g.start;
    for (const choice of trail) {
      const current = config.nodes[node];
      if (!current || current.game !== game || !Number.isInteger(choice) || !current.options[choice]) return null;
      const option = current.options[choice];
      if (option.result) {
        node = 'result:' + option.result;
      } else node = option.next;
    }
    if (node.startsWith('result:')) {
      const result = node.slice(7);
      return config.results[result] && config.results[result].game === game ? {result} : null;
    }
    return config.nodes[node] ? {node} : null;
  }
  const api = {route, selectProducts, sizeIndex};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  scope.JFPlayCore = api;
  if (typeof document === 'undefined') return;
  const mounted = new WeakSet();
  function mount(root) {
    if (mounted.has(root)) return;
    mounted.add(root);
    const read = selector => JSON.parse(root.querySelector(selector).textContent);
    const C = read('[data-play-config]');
    const catalog = read('[data-play-catalog]');
    const ui = C.ui;
    const stage = root.querySelector('[data-play-stage]');
    const live = root.querySelector('[data-play-status]');
    const key = 'jf-play:' + location.pathname;
    const locale = catalog.locale || 'pt-PT';
    const money = amount => new Intl.NumberFormat(locale, {style:'currency', currency:catalog.currency || 'EUR'}).format(amount / 100);
    const products = [];
    const seen = new Map();
    catalog.products.forEach(p => {
      const previous = seen.get(p.id);
      if (previous) previous.collections = [...new Set(previous.collections.concat(p.collections))];
      else {seen.set(p.id, p); products.push(p);}
    });
    let state = {version:C.version, game:null, trail:[], filters:{size:'', budget:''}, duo:{owner:[], guesses:[], phase:'owner'}};
    let lastResult = null;
    let selectedCollection = null;
    let first = true;
    let checking = false;
    let renderToken = 0;
    const onReset = () => { try {sessionStorage.removeItem(key);} catch (_) {} };
    const persist = () => { try {sessionStorage.setItem(key, JSON.stringify(state));} catch (_) {} };
    function emit(name, details) {
      const payload = Object.assign({experience:state.game, version:C.version}, details || {});
      root.dispatchEvent(new CustomEvent('jfplay:' + name, {bubbles:true, detail:payload}));
      const consent = scope.Shopify && scope.Shopify.customerPrivacy;
      if (consent && typeof consent.analyticsProcessingAllowed === 'function' && consent.analyticsProcessingAllowed()) {
        try { scope.Shopify.analytics.publish('jf_play_' + name, payload); } catch (_) {}
      }
    }
    function image(name, alt, cls) {
      return C.images[name] ? '<img class="' + esc(cls || '') + '" src="' + esc(C.images[name]) + '" alt="' + esc(alt || '') + '" loading="eager" width="900" height="1000">' : '';
    }
    function notice(text) { live.textContent = text; }
    function paint(html, focus) {
      renderToken += 1;
      stage.innerHTML = html;
      if (!first && focus !== false) {
        const heading = stage.querySelector('[data-focus]');
        if (heading) {heading.focus({preventScroll:true}); const rect = heading.getBoundingClientRect(); if (rect.top < 0 || rect.top > innerHeight * .6) heading.scrollIntoView({block:'start', behavior:'instant'});}
      }
      first = false;
    }
    function bar(back) {
      return '<nav class="jfp-nav" aria-label="' + esc(ui.home) + '"><button data-action="home">← ' + esc(ui.home) + '</button>' + (back ? '<button data-action="back">' + esc(ui.back) + '</button>' : '') + '</nav>';
    }
    function setUrl(result) {
      const url = new URL(location.href);
      url.searchParams.delete('final'); url.searchParams.delete('jogo'); url.searchParams.delete('jfv');
      if (result) {url.searchParams.set('jfv', C.version); url.searchParams.set('final', result);}
      else if (state.game) url.searchParams.set('jogo', state.game);
      history.replaceState(null, '', url);
    }
    function resultUrl(id) {
      const url = new URL(location.href); url.search = ''; url.hash = '';
      url.searchParams.set('jfv', C.version); url.searchParams.set('final', id);
      return url.href;
    }
    function home() {
      lastResult = null; selectedCollection = null;
      const canResume = state.game && (state.game === 'duo' || route(C, state.game, state.trail));
      paint('<header class="jfp-heading"><p class="jfp-kicker">' + esc(ui.eyebrow) + '</p><h1 data-focus tabindex="-1">' + esc(ui.title) + '</h1><p>' + esc(ui.intro) + '</p></header>' +
        (canResume ? '<div class="jfp-resume"><button class="jfp-button" data-action="resume">' + esc(ui.resume) + ' ↗</button><button class="jfp-text-button" data-action="clear">' + esc(ui.clear) + '</button></div>' : '') +
        '<div class="jfp-games">' + C.games.map((g,i) => '<button class="jfp-game jfp-game--' + i + '" data-game="' + esc(g.id) + '"><span class="jfp-game-image">' + image(g.image, g.alt) + '</span><span class="jfp-game-copy"><span class="jfp-kicker">' + esc(g.meta) + '</span><strong>' + esc(g.title) + '</strong><span>' + esc(g.description) + '</span><span class="jfp-game-cta">' + esc(ui.play) + ' <span aria-hidden="true">↗</span></span></span></button>').join('') + '</div><p class="jfp-footnote">' + esc(ui.saved) + '</p>');
    }
    function start(game) {
      if (!C.games.some(g => g.id === game)) return home();
      state = {version:C.version, game, trail:[], filters:state.filters, duo:{owner:[], guesses:[], phase:'owner'}};
      emit('start'); persist(); setUrl(); render();
    }
    function render() {
      if (!state.game) return home();
      if (state.game === 'duo') return renderDuo();
      if (state.final && C.results[state.final] && C.results[state.final].game === state.game) return result(state.final);
      const current = route(C, state.game, state.trail);
      if (!current) {onReset(); state.game=null; notice(ui.resetNotice); return home();}
      if (current.result) return result(current.result);
      const n = C.nodes[current.node];
      const visual = n.options.some(o => o.image);
      paint(bar(state.trail.length > 0) + '<div class="jfp-scene' + (!n.image ? ' jfp-scene--wide' : '') + '"><div class="jfp-scene-copy"><p class="jfp-kicker">' + esc(ui.choice) + ' ' + (state.trail.length + 1) + '</p><h2 data-focus tabindex="-1">' + esc(n.title) + '</h2><p class="jfp-body">' + esc(n.body) + '</p><div class="jfp-options' + (visual ? ' jfp-options--visual' : '') + '">' + n.options.map((o,i) => '<button class="jfp-option" data-choice="' + i + '">' + (o.image ? image(o.image,o.alt) : '') + '<span>' + esc(o.label) + '</span><b aria-hidden="true">↗</b></button>').join('') + '</div></div>' + (n.image ? '<div class="jfp-scene-image">' + image(n.image,n.alt) + '</div>' : '') + '</div>');
    }
    function result(id) {
      const r = C.results[id];
      if (!r) return home();
      lastResult = id; selectedCollection = r.collection || null; state.game = r.game; state.final = id; persist(); setUrl(id);
      paint(bar(state.trail.length > 0) + '<article class="jfp-result"><div class="jfp-result-image">' + image(r.image,r.alt) + '</div><div class="jfp-result-copy"><p class="jfp-kicker">' + esc(ui.ending) + '</p><h2 tabindex="-1" data-focus>' + esc(r.title) + '</h2><p class="jfp-body">' + esc(r.body) + '</p><div class="jfp-result-actions">' + (r.collection ? '<button class="jfp-button" data-action="products">' + esc(ui.products) + ' ↗</button>' : '') + '<button class="jfp-text-button" data-action="share">' + esc(ui.share) + '</button><button class="jfp-text-button" data-action="copy">' + esc(ui.copy) + '</button><button class="jfp-text-button" data-action="card">' + esc(ui.saveCard) + '</button><button class="jfp-text-button" data-action="restart">' + esc(ui.restart) + '</button></div></div></article><div data-shopping></div>');
    }
    function renderDuo() {
      const d = state.duo;
      if (d.phase === 'handoff') {
        return paint(bar(false) + '<div class="jfp-handoff"><span class="jfp-handoff-icon" aria-hidden="true">↔</span><h2 data-focus tabindex="-1">' + esc(ui.handoffTitle) + '</h2><p>' + esc(ui.handoffBody) + '</p><button class="jfp-button" data-action="handoff">' + esc(ui.handoffStart) + ' →</button></div>');
      }
      if (d.phase === 'done') {
        const score = d.owner.filter((v,i) => v === d.guesses[i]).length;
        const o = C.rounds[0].options[d.owner[0]];
        selectedCollection = o.collection;
        paint(bar(false) + '<div class="jfp-duo-result"><p class="jfp-kicker">' + esc(ui.friendResult) + '</p><h2 data-focus tabindex="-1" class="jfp-score">' + score + '<span>/3</span></h2><p class="jfp-body">' + esc(score === 3 ? ui.friendPerfect : score === 2 ? ui.friendGood : ui.friendLow) + '</p><h3>' + esc(ui.friendReveal) + '</h3><div class="jfp-reveal">' + C.rounds.map((round,i) => '<section><h4>' + esc(round.title) + '</h4><p><span>' + esc(ui.friendActual) + '</span>' + esc(round.options[d.owner[i]].label) + '</p><p><span>' + esc(ui.friendGuessed) + '</span>' + esc(round.options[d.guesses[i]].label) + (d.owner[i] === d.guesses[i] ? ' ✓' : '') + '</p></section>').join('') + '</div><div class="jfp-result-actions"><button class="jfp-button" data-action="products">' + esc(ui.friendShop) + ' ↗</button><button class="jfp-text-button" data-action="restart">' + esc(ui.friendAgain) + '</button></div><p class="jfp-footnote">' + esc(ui.friendNoShare) + '</p></div><div data-shopping></div>');
        return;
      }
      const owner = d.phase === 'owner';
      const index = owner ? d.owner.length : d.guesses.length;
      const round = C.rounds[index];
      paint(bar(owner && index > 0) + '<div class="jfp-duo"><p class="jfp-kicker">' + esc(owner ? ui.friendOwner : ui.friendGuess) + ' · ' + (index + 1) + '/3</p><h2 data-focus tabindex="-1">' + esc(round.title) + '</h2>' + (owner && index === 0 ? '<p class="jfp-body">' + esc(ui.friendIntro) + '</p>' : '') + '<div class="jfp-options' + (round.options.some(o=>o.image) ? ' jfp-options--characters' : '') + '">' + round.options.map((o,i) => '<button class="jfp-option" data-duo="' + i + '">' + (o.image ? image(o.image,o.alt) : '') + '<span>' + esc(o.label) + '</span><b aria-hidden="true">↗</b></button>').join('') + '</div></div>');
    }
    function shopping() {
      const host = stage.querySelector('[data-shopping]');
      if (!host || !selectedCollection) return;
      const sizes = new Set();
      products.filter(p=>p.collections.includes(selectedCollection)).forEach(p => {const i=sizeIndex(p); if(i>=0) p.variants.forEach(v => {if(v.available && sizeNumber(v.options[i])>=(catalog.minSize || 35)) sizes.add(v.options[i]);});});
      const reason = lastResult ? C.results[lastResult].reason : ui.matchReason;
      host.innerHTML = '<section class="jfp-shopping"><p class="jfp-kicker">' + esc(selectedCollection) + '</p><h3 tabindex="-1" data-shop-focus>' + esc(ui.matches) + '</h3><p>' + esc(reason) + '</p><form class="jfp-filters"><label>' + esc(ui.size) + '<select name="size" required><option value="">—</option>' + [...sizes].sort((a,b)=>sizeNumber(a)-sizeNumber(b)).map(s=>'<option value="'+esc(s)+'"'+(state.filters.size===s?' selected':'')+'>'+esc(s)+'</option>').join('') + '<option value="unknown"' + (state.filters.size==='unknown'?' selected':'') + '>' + esc(ui.unknownSize) + '</option></select></label><label>' + esc(ui.budget) + '<select name="budget"><option value="">' + esc(ui.anyBudget) + '</option>' + [5000,7500,10000,15000].map(b=>'<option value="'+b+'"'+(String(state.filters.budget)===String(b)?' selected':'')+'>'+esc(money(b))+'</option>').join('') + '</select></label><button class="jfp-button" type="submit">' + esc(ui.apply) + ' →</button></form><p class="jfp-footnote">' + esc(ui.sizeHint) + ' ' + esc(ui.rangeHint) + ' ' + esc(catalog.minSize || 35) + '. ' + esc(ui.currencyHint) + '</p><div data-product-list></div></section>';
      host.querySelector('[data-shop-focus]').focus({preventScroll:true});
      host.scrollIntoView({block:'start', behavior:'instant'});
      if (state.filters.size && (state.filters.size === 'unknown' || sizes.has(state.filters.size))) renderProducts();
    }
    function renderProducts() {
      const host = stage.querySelector('[data-product-list]');
      if (!host) return;
      const matches = selectProducts(products, selectedCollection, state.filters.size, Number(state.filters.budget) || Infinity, catalog.minSize || 35);
      const collection = catalog.collections.find(c=>c.handle===selectedCollection);
      const collectionLink = collection && collection.url ? '<a class="jfp-text-button" href="' + esc(collection.url) + '" data-collection="' + esc(collection.handle) + '">' + esc(ui.collection) + ' ↗</a>' : '';
      if (!matches.length) {
        host.innerHTML = '<div class="jfp-empty" role="status"><h4>' + esc(ui.noMatch) + '</h4><p>' + esc(ui.noMatchHelp) + '</p>' + collectionLink + '</div>';
        return;
      }
      host.innerHTML = '<p class="jfp-stock-note" role="status">' + esc(state.filters.size === 'unknown' ? ui.unknownHint : ui.knownHint) + '</p><div class="jfp-products">' + matches.map(({product:p,variant:v})=>'<article class="jfp-product"><img src="'+esc(p.image)+'" alt="'+esc(p.title)+'" width="600" height="600" loading="lazy"><div><p class="jfp-kicker">'+esc(p.vendor)+'</p><h4>'+esc(p.title)+'</h4><p>'+esc(money(v.price))+(state.filters.size==='unknown'?'':' · '+esc(ui.size)+' '+esc(state.filters.size))+'</p><button class="jfp-button" data-product="'+esc(p.id)+'" data-variant="'+esc(v.id)+'">'+esc(ui.view)+' ↗</button></div></article>').join('')+'</div>'+collectionLink;
      emit('recommendations', {outcome:lastResult || 'duo', count:matches.length});
    }
    async function openProduct(button) {
      if (checking) return;
      const p = products.find(item=>item.id === button.dataset.product);
      const v = p && p.variants.find(item=>item.id === button.dataset.variant);
      if (!p || !v) return;
      const url = new URL(p.url, location.origin);
      if (catalog.preview) {notice(ui.preview); return;}
      const token = renderToken;
      checking = true; button.disabled = true; button.textContent = ui.checking;
      try {
        const controller = new AbortController(); const timer = setTimeout(()=>controller.abort(), 8000);
        let response;
        try {response = await fetch(url.pathname.replace(/\/$/, '') + '.js', {signal:controller.signal});} finally {clearTimeout(timer);}
        if (!response.ok) throw new Error('unavailable');
        const fresh = await response.json();
        const fv = fresh.variants.find(item=>String(item.id)===v.id);
        if (token !== renderToken) return;
        if (!fv || !fv.available || fv.price !== v.price) {
          if (fv) {v.available=fv.available; v.price=fv.price;} else v.available=false;
          renderProducts(); notice(ui.changed); return;
        }
        if (state.filters.size !== 'unknown') url.searchParams.set('variant', v.id);
        url.searchParams.set('jf_experience', state.game); url.searchParams.set('jf_outcome', lastResult || 'duo');
        persist(); emit('product_click', {outcome:lastResult || 'duo', productId:p.id, variantId:state.filters.size==='unknown'?null:v.id});
        location.assign(url.href);
      } catch (_) {
        if (token === renderToken) {
          notice(ui.unverified);
          const link = document.createElement('a'); link.className='jfp-text-button'; link.href=p.url; link.textContent=ui.direct;
          link.addEventListener('click',()=>emit('product_unverified_click',{productId:p.id,outcome:lastResult || 'duo'}));
          button.parentNode.append(link);
        }
      } finally {checking=false; if(button.isConnected){button.disabled=false;button.textContent=ui.view+' ↗';}}
    }
    async function copyLink() {
      if (!lastResult) return;
      const url=resultUrl(lastResult);
      try {await navigator.clipboard.writeText(url); notice(ui.copied); emit('link_copy',{outcome:lastResult});}
      catch (_) {live.replaceChildren(); const label=document.createElement('label');label.textContent=ui.copyFallback; const input=document.createElement('input'); input.value=url;input.readOnly=true;input.setAttribute('aria-label',ui.resultLink);label.append(input);live.append(label);input.focus();input.select();}
    }
    async function share() {
      if (!lastResult) return;
      const r=C.results[lastResult]; emit('share_attempt',{outcome:lastResult});
      if (!navigator.share) return copyLink();
      try {await navigator.share({title:r.title,text:r.body,url:resultUrl(lastResult)});emit('share_api_complete',{outcome:lastResult});}
      catch(error){if(error.name==='AbortError') emit('share_cancel',{outcome:lastResult});else notice(ui.shareError);}
    }
    async function saveCard() {
      if (!lastResult || state.game === 'duo') return;
      const id=lastResult, r=C.results[id];
      try {
        const picture = new Image(); picture.crossOrigin='anonymous';
        await new Promise((resolve,reject)=>{const timer=setTimeout(()=>reject(new Error('timeout')),8000);picture.onload=()=>{clearTimeout(timer);resolve();};picture.onerror=()=>{clearTimeout(timer);reject(new Error('image'));};picture.src=C.images[r.image];});
        const canvas=document.createElement('canvas');canvas.width=1080;canvas.height=1600;
        const ctx=canvas.getContext('2d');ctx.fillStyle='#101011';ctx.fillRect(0,0,1080,1600);
        ctx.fillStyle='#ff3029';ctx.fillRect(0,0,1080,20);ctx.fillStyle='#f4f1e9';ctx.font='bold 29px Arial';ctx.fillText('JUSTFREE.ME',64,85);
        const scale=Math.min(950/picture.width,780/picture.height);ctx.drawImage(picture,(1080-picture.width*scale)/2,125+(780-picture.height*scale)/2,picture.width*scale,picture.height*scale);
        function textBlock(text,y,size,width,lineHeight){ctx.font='bold '+size+'px Arial';let line='';for(const word of text.split(/\s+/)){const test=line?line+' '+word:word;if(ctx.measureText(test).width>width && line){ctx.fillText(line,64,y);y+=lineHeight;line=word;}else line=test;}if(line)ctx.fillText(line,64,y);return y+lineHeight;}
        ctx.fillStyle='#f4f1e9';const y=textBlock(r.title.toUpperCase(),1000,68,950,78);
        ctx.fillStyle='#c9c5be';ctx.font='26px Arial';textBlock(r.body,y+30,28,950,38);
        ctx.fillStyle='#ff3029';ctx.fillRect(64,1370,950,3);ctx.fillStyle='#f4f1e9';ctx.font='bold 23px Arial';ctx.fillText(ui.cardInvitation,64,1425);
        const link=resultUrl(id).replace(/^https?:\/\//,'');ctx.font='21px Arial';
        const width=950;let line='',lineY=1470;
        for(const char of link){if(ctx.measureText(line+char).width>width){ctx.fillText(line,64,lineY);lineY+=28;line=char;}else line+=char;}ctx.fillText(line,64,lineY);
        const blob=await new Promise(resolve=>canvas.toBlob(resolve,'image/png'));
        if(!blob)throw new Error('blob');const url=URL.createObjectURL(blob);const a=document.createElement('a');a.href=url;a.download='justfree-'+id+'.png';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);emit('card_download',{outcome:id});
      }catch(_){notice(ui.cardError);}
    }
    root.addEventListener('submit', e => {
      if (!e.target.matches('.jfp-filters')) return;
      e.preventDefault(); const data=new FormData(e.target);
      state.filters={size:String(data.get('size') || ''),budget:String(data.get('budget') || '')};
      if (!state.filters.size) return notice(ui.pickSize);
      persist(); renderProducts();
    });
    root.addEventListener('click', e => {
      const target=e.target.closest('button,a'); if(!target || !root.contains(target))return;
      if (target.dataset.game) return start(target.dataset.game);
      if (target.hasAttribute('data-choice')) {
        const current=route(C,state.game,state.trail); if(!current || !current.node)return;
        const index=Number(target.dataset.choice); if(!C.nodes[current.node].options[index])return;
        state.trail.push(index);persist();emit('choice',{node:current.node});const next=route(C,state.game,state.trail);if(next.result)emit('complete',{outcome:next.result});return render();
      }
      if (target.hasAttribute('data-duo')) {
        const d=state.duo;const owner=d.phase==='owner';const index=owner?d.owner.length:d.guesses.length;
        if(!C.rounds[index] || !C.rounds[index].options[Number(target.dataset.duo)])return;
        (owner?d.owner:d.guesses).push(Number(target.dataset.duo));
        if(owner && d.owner.length===3)d.phase='handoff';else if(!owner && d.guesses.length===3){d.phase='done';emit('complete',{outcome:'duo'});}
        persist();return renderDuo();
      }
      if(target.dataset.product)return openProduct(target);
      if(target.dataset.collection)emit('collection_click',{outcome:lastResult || 'duo',collection:target.dataset.collection});
      switch(target.dataset.action){
        case 'home': {const url=new URL(location.href);url.searchParams.delete('final');url.searchParams.delete('jogo');url.searchParams.delete('jfv');history.replaceState(null,'',url);return home();}
        case 'clear': onReset();state.game=null;state.trail=[];state.filters={size:'',budget:''};return home();
        case 'resume': setUrl();return render();
        case 'restart': return start(state.game);
        case 'back': if(state.game==='duo'){if(state.duo.phase==='owner')state.duo.owner.pop();}else{delete state.final;state.trail.pop();setUrl();}persist();return render();
        case 'handoff':state.duo.phase='guess';persist();return renderDuo();
        case 'products':return shopping();
        case 'share':return share();
        case 'copy':return copyLink();
        case 'card':return saveCard();
      }
    });
    try {
      const saved=JSON.parse(sessionStorage.getItem(key));
      if(saved && saved.version===C.version && C.games.some(g=>g.id===saved.game) && Array.isArray(saved.trail) && saved.filters && saved.duo){
        const d=saved.duo;
        const validDuo=['owner','handoff','guess','done'].includes(d.phase) && Array.isArray(d.owner) && Array.isArray(d.guesses) && d.owner.length<=3 && d.guesses.length<=3 && d.owner.every((v,i)=>Number.isInteger(v)&&C.rounds[i].options[v]) && d.guesses.every((v,i)=>Number.isInteger(v)&&C.rounds[i].options[v]) && (d.phase==='owner'?d.owner.length<3:d.owner.length===3) && (d.phase==='done'?d.guesses.length===3:d.guesses.length<3);
        if(saved.game==='duo'?validDuo:route(C,saved.game,saved.trail))state=saved;
      }
    }catch(_){onReset();}
    const params=new URLSearchParams(location.search);
    if(params.has('final')){
      const id=params.get('final');
      if(params.get('jfv')===C.version && C.results[id]){if(!route(C,state.game,state.trail) || route(C,state.game,state.trail).result!==id){state.game=C.results[id].game;state.trail=[];}result(id);}
      else{notice(ui.invalid);home();}
    }else if(params.get('jogo')){
      const game=params.get('jogo');if(game===state.game)render();else start(game);
    }else home();
  }
  function scan(scopeRoot){scopeRoot.querySelectorAll('[data-jf-play]').forEach(mount);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document));else scan(document);
  document.addEventListener('shopify:section:load',e=>scan(e.target));
})(typeof globalThis !== 'undefined' ? globalThis : this);


  } catch(e) { console.error(e); }
})();
})();
